






























































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Component } from "vue-property-decorator";
import ProgressBar from '@/components/common/ProgressBar/ProgressBar.vue';
import WorkflowButtons from '@/components/common/ProgressBar/WorkflowButtons.vue';
import LeftNavigationComponent from "../Workspace/Components/LeftNavigation.vue";
import AmendmentRequest from './AmendmentRequest.vue';
import Sign from './Sign.vue';
import Summary from './Summary.vue';
import NoCostExtension from './Components/NoCostExtension.vue';
import AmendmentTypes from './Components/AmendmentTypes.vue';
import ValidationMessage from '@/components/common/ValidationMessage/ValidationMessage.vue';
import { AppConstants as _app } from "@/shared/app.constants";
import { GrantData, GrantAmendmentData } from "@/entities";
import { Utilities as utils } from "@/shared/utilities";
import { User } from "oidc-client";
import AuthService from "@/services/auth.service";
import { Locales } from "@/i18n/locales";

const namespace: string = "grantAmendment";
const auth = new AuthService();

@Component({
    components: {
        LeftNavigationComponent,
        ProgressBar,
        WorkflowButtons,
        AmendmentRequest,
        ValidationMessage,
        Sign,
        Summary,
        NoCostExtension,
        AmendmentTypes
    }
})
export default class WorkspaceComponent extends Vue {
    @State(namespace) grantAmendment!: GrantAmendmentData;
    @Action("getAmendmentById", { namespace }) getAmendmentById: any;
    @Action("updateAmendment", { namespace }) save: any;
    @Action("UpdateAmendmentDetailData", { namespace }) updateAmendmentDetailData: any;
    @Action("UpdateAmendmentData", { namespace }) updateAmendmentData: any;

    selectedKey: string = 'summary';
    showSideBar = true;
    grantDataLoaded: boolean = false;
    docTags: any = [];
    actions = _app.actions;
    subjects = _app.subjects;
    isDirty: boolean = false;
    userTypeId?: number = null;
    userRoleId?: number = null;
    componentKey = 0;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    mounted() {
        auth.isLoggedIn().then((isLoggedIn) => {
            if (isLoggedIn) {
                auth.getUser().then((user: User) => {
                    this.userTypeId = Number(user.profile.user_type_id);
                    this.userRoleId =  Number(user.profile.role_id); 
                });
            }
        });

        this.$services.document.documentTagBySection(['Grant Amendment'])
            .then((data) => {
                this.docTags = data;
            })
    }

    /** computed property workflow items */
    get workFlowItems() {
        return this.grantAmendment.grantAmendment.WorkflowInfo || {}
    }

    get subSections() {
        if ([_app.UserType.SystemAdmin, _app.UserType.Secretariat].includes(this.userTypeId) && (this.grantAmendment.grantAmendment.WorkflowStatusCode === 'APRV' || this.grantAmendment.grantAmendment.WorkflowStatusCode === 'SGN' )) {
            return _app.amendmentSections;
        } else {
            let newObj = JSON.parse(JSON.stringify(_app.amendmentSections));
            delete newObj['properties']['sign'];
            return newObj;
        }
    }

    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any) {
        this.componentKey += 1;
        if (changedRoute && changedRoute.name === 'amendment') {
            this.getAmendment();
        }
        if(changedRoute.hash){
            this.selectedKey = changedRoute.hash.slice(1);
        }
    }

    /**  update the sub menu on left panel selection */
    subMenuChanged(selectedMenu, key) {
        this.selectedKey = key;
        window.location.hash = `#${this.selectedKey}`;
    }

    sidebarToggle() {
        this.showSideBar = !this.showSideBar;
    }

    formatCurrency(val, currency) {
        return utils.formatCurrency(val, currency, this.defaultLocale);
    }

    getAmendment() {
        this.getAmendmentById(this.$route.params.amendmentId)
            .then((data) => {
                if (data) {
                }
            });
    }

    /** update the workflow status */
    updateStatus(item) {
        this.grantAmendment.grantAmendment.WorkflowStatusId = item.StepId;
        this.grantAmendment.grantAmendment.Comments = item.Comments;
        this.grantAmendment.grantAmendment.Subject = item.Subject;
        this.grantAmendment.grantAmendment.notify = item.notify;

        this.save({
            data: this.grantAmendment.grantAmendment,
            id: this.grantAmendment.grantAmendment.GrantAmendmentId
        }).then(() => {
            this.getAmendment();
        });
        (this.$refs.workflowButtonRef as InstanceType<typeof WorkflowButtons>).enableAllButtons();
    }

    saveAmendment() {
        if (this.isDirty) {
            return this.updateAmendmentData({
                id: this.grantAmendment.grantAmendment.GrantAmendmentId,
                data: {
                    grantAmendment: this.grantAmendment.grantAmendment,
                    grantAmendmentDetailData: this.grantAmendment.grantAmendmentDetailData
                }
            }).then(() => {
                this.isDirty = false;
                this.getAmendment();                
            });
        }
        else
        {
            return Promise.resolve();
        }
    }
    
    setDirty() {
        this.isDirty = true;
    }

    /** Add new file to the physical location*/
    onFileChanged(data: any) {
        this.saveAmendment();        
    }

    back() {
        var grantId = this.grantAmendment.grantInfo.GrantId.toString();
        this.$router.push({
            name: "grantSummary",
            params: { grantId: grantId }
        });
    }

    get permission() {
        //@ts-ignore
        return this.$can(this.actions.manage, this.subjects.amendment);
    }

    showValidation(msgs: any) {
        this.grantAmendment.validationMessages = msgs;
        this.grantAmendment.showValidationDilog = true;
    }

    rollback(e) {        
        this.getAmendment();
    }

    validationMessageClosed() {
        this.grantAmendment.showValidationDilog = false;
        (this.$refs.workflowButtonRef as InstanceType<typeof WorkflowButtons>).enableAllButtons();
    }
}
